<script>
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyConfirmDialog',
  props: {
    title: { type: String, required: true },
    saveButtonLabel: { type: String, required: false, default: i18n.tc('common.save') },
    cancelButtonLabel: { type: String, required: false, default: i18n.tc('common.cancel') },
    dialogType: { type: String, required: false, default: 'success' },
  },
  computed: {
    forwardedSlots() {
      return Object.keys(this.$scopedSlots).reduce((slots, slotKey) => {
        /* eslint-disable no-param-reassign */
        slots[slotKey] = this.$scopedSlots[slotKey];
        /* eslint-enable no-param-reassign */
        return slots;
      }, {});
    },
    saveLabel() {
      return this.$attrs.saveButtonLabel || this.saveButtonLabel;
    },
    cancelLabel() {
      return this.$attrs.cancelButtonLabel || this.cancelButtonLabel;
    },
    confirmStyle() {
      if (this.dialogType === 'success' || this.dialogType === 'danger') {
        return this.dialogType;
      }
      return 'success';
    },
  },
  methods: {
    confirmClicked() {
      this.$emit('confirm');
    },
    cancelClicked() {
      this.$emit('cancel');
    },
  },
});
</script>
<template>
  <el-dialog
    destroy-on-close
    class="cly-vue-confirm-dialog"
    v-bind="$attrs"
    :title="title"
    v-on="$listeners"
  >
    <template #title>
      <h3 class="color-cool-gray-100">
        {{ title }}
      </h3>
    </template>
    <template
      v-for="(_, name) in forwardedSlots"
      #[name]
    >
      <slot :name="name" />
    </template>
    <template #footer>
      <div class="cly-vue-formdialog__buttons is-single-step bu-is-justify-content-flex-end bu-is-flex">
        <el-button
          size="small"
          type="secondary"
          @click="cancelClicked"
        >
          {{ cancelLabel }}
        </el-button>
        <el-button
          v-if="confirmStyle=='success'"
          size="small"
          type="success"
          @click="confirmClicked"
        >
          {{ saveLabel }}
        </el-button>
        <el-button
          v-else
          size="small"
          type="danger"
          @click="confirmClicked"
        >
          {{ saveLabel }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
